import { useEffect, useState } from 'react';
import { wsClient, type WsConnectionState } from './ws-client';
import type { AdminChannel, ChannelPayloadMap } from './types';

/**
 * 订阅一个 WS 频道。组件卸载时自动取消。
 *
 * @param channel 频道名(signals / system / ctid_status / risk_events / quote)
 * @param handler 收到事件时的回调(payload 类型由 channel 推导)
 * @param deps    handler 闭包依赖,默认空数组(handler 必须用 useCallback 或本身稳定)
 */
export function useChannel<C extends AdminChannel>(
  channel: C,
  handler: (payload: ChannelPayloadMap[C]) => void,
  deps: React.DependencyList = [],
): void {
  useEffect(() => {
    const unsubscribe = wsClient.subscribe(channel, handler);
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, ...deps]);
}

/** 监听 WS 连接状态(open / connecting / reconnecting / idle),用于顶栏指示灯 */
export function useWsStatus(): WsConnectionState {
  const [state, setState] = useState<WsConnectionState>('idle');
  useEffect(() => wsClient.onStatusChange(setState), []);
  return state;
}
